export default __webpack_public_path__ + "static/media/sky-the-limit.fd21e779.webp";